/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation ContactBookDeleteMutation($contactBookId: ID!) {
  ContactBookDelete(contactBookId: $contactBookId) {
    id
    message
    status
  }
}
`
